import { StoreCategory } from '@gooduncles/gu-app-schema';
import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from 'src/layout/Loading';

import { selectStore } from 'src/redux/slices/auth';
import {
  selectCustomPromotionSections,
  selectPromotionSections,
  selectSelectedStoreCategory,
} from 'src/redux/slices/home';
import { selectProductGroupForCategory } from 'src/redux/slices/home';
import { useAppSelector } from 'src/redux/store';

import { useApp } from 'src/stores/app-context';

import IconArrowRight from 'src/assets/icons/arrow-right.svg';

import RectButton from 'src/components/atoms/Button/RectButton';
import HomeSectionDivider from 'src/components/atoms/Divider/HomeSectionDivider';
import Footer from 'src/components/atoms/Footer/Footer';
import HomeToolbar from 'src/components/templates/HomeToolbar/HomeToolbar';
import LatestOrderProductList from 'src/components/templates/LatestOrderProductList/LatestOrderProductList';
import MainTagListForStoreCategory from 'src/components/templates/MainTagListForStoreCategory/MainTagListForStoreCategory';
import ProductListForPromotion from 'src/components/templates/ProductListForPromotion/ProductListForPromotion';

import classes from './Home.module.scss';

const Home: FC = () => {
  const navigate = useNavigate();
  const { commerceConf } = useApp();
  const store = useAppSelector(selectStore);
  const selectedStoreCategory = useAppSelector(selectSelectedStoreCategory);
  const selectedPromotionSections = useAppSelector(selectPromotionSections);
  const customPromotionSecitons = useAppSelector(selectCustomPromotionSections);
  const promotionSections = useMemo(
    () => [...selectedPromotionSections, ...customPromotionSecitons].sort((a, b) => a.positionIndex - b.positionIndex),
    [customPromotionSecitons, selectedPromotionSections]
  );
  const storeCategory: string = selectedStoreCategory ?? store?.categories?.[0] ?? 'all';

  const productGroupForCategory = useAppSelector((state) => selectProductGroupForCategory(state, storeCategory));

  return (
    <>
      <HomeToolbar storeCategory={storeCategory} />
      <>
        {commerceConf.notice && <div className={classes.noticeBar}>{commerceConf.notice}</div>}
        <div>
          {/* 최근 주문 상품 */}
          {store && <LatestOrderProductList />}
          {promotionSections.map((section) => (
            <HomeSectionDivider style={{ marginBottom: 30 }} key={section._id}>
              <ProductListForPromotion promotionSection={section} />
            </HomeSectionDivider>
          ))}
          <HomeSectionDivider>
            <h2>
              {productGroupForCategory?.emoji} <b>{productGroupForCategory?.title}</b> 매장에서 많이 구매하는 상품
            </h2>
          </HomeSectionDivider>
          {productGroupForCategory?.mainTags ? (
            <MainTagListForStoreCategory
              storeCategory={storeCategory as StoreCategory}
              mainTags={productGroupForCategory.mainTags.slice(0, productGroupForCategory.maxItemsToShow)}
            />
          ) : (
            <Loading />
          )}
          <div className={classes.more}>
            <RectButton
              label={
                <>
                  <b>{productGroupForCategory?.title}</b> 인기 상품 더 보기
                </>
              }
              style={{ marginBottom: 30 }}
              onClick={() => {
                const htmlElement = document.documentElement;
                navigate(`/store-category/${storeCategory}`);
                htmlElement.scrollTo({ top: 0, behavior: 'auto' });
              }}>
              <img src={IconArrowRight} alt='arrow right' />
            </RectButton>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default Home;
